import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/blood-bank-banner.png';
import '../styles/pages.css';

function BloodBank() {
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Blood Bank</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Ensuring reliable blood bank services through advanced
                            <br/> 
                            technology and expert care.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Ensuring reliable blood bank services through advanced technology and expert care.
                        </p>
                    </div>

                    <div className="page-box">
                        <div className="box-content">
                            <p>At Caritas Matha Hospital, our Blood Bank operates with state-of-the-art technology and is staffed by highly skilled professionals who rigorously adhere to strict protocols for donor screening, blood collection, testing, and storage.With a focus on community health, we uphold top standards in blood banking to meet critical patient needs.</p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Clinical Nutrition" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='page-content'>
                    <p className='page-content-heading'>
                        24/7 Lifesaving Support: Your Beacon of Hope
                        <br />for Transfusion Medicine
                    </p>
                    <br />
                    <div className='page-details'>
                        <p>Caritas Matha Hospital boasts a state-of-the-art blood bank that operates round-the-clock, providing essential transfusion medicine services to both inpatients and outpatients in critical need of blood or its components. Our blood bank is equipped with the latest technology and staffed by experienced experts, ensuring efficient and reliable services at every step of the process—from donor screening and blood collection to component separation and scientific storage.</p>
                        <br />
                        
                        <h5>Services Offered by the Blood Bank : </h5>
                        <br />

                        <h6>Blood Grouping And Testing : </h6>
                        <br />
                        <ul>    
                            <li><p>Includes comprehensive blood grouping such as A1/A2, Bombay group, and Du detection. We perform cross matching using the Gel card system with methods like saline, albumin, and Coomb’s method.</p></li>
                        </ul>
                        <br />

                        <h6>Antibody Screening : </h6>
                        <br />
                        <ul>
                            <li><p>Conducts Direct Antiglobulin Test (DAT/DCT), Indirect Antiglobulin Test (IAT/ICT), Cold Agglutinin Test, and Titer to ensure compatibility and safety of blood transfusions.</p></li>
                        </ul>
                        <br />

                        <h6>Component Preparation : </h6>
                        <br />
                        <ul>
                            <li><p>Utilizes fully automated, closed, sterile extractor systems (T-ACE-II) for precise preparation of blood components including Packed Red Cells (PRC), Fresh Frozen Plasma (FFP), Platelet Concentrate, and Cryoprecipitate.</p></li>
                        </ul>
                        <br />

                        <h6>Specialized Procedures</h6>
                        <br />
                        <ul>
                            <li><p>Offers single donor platelets through apheresis procedures, ensuring high-quality and safe transfusion options for patients.</p></li>
                        </ul>
                        <br />

                        <h6>Safety Protocols</h6>
                        <br />
                        <ul>
                            <li><p>Blood preparations undergo thorough screening for transfusion-transmissible infections including HIV 1 & 2, Hepatitis C Virus, Hepatitis B Virus, and Syphilis. Additionally, we employ Malarial parasite Antigen detection kits and screen for unexpected antibodies using IAT.</p></li>
                        </ul>
                        <br />

                        <h6>Storage and Distribution</h6>
                        <br />
                        <ul>
                            <li><p>Maintains adequate and appropriate storage units for blood components, ensuring their integrity and safety. Blood component units are available for issuance to other hospitals upon request, subject to availability.</p></li>
                        </ul>
                        <br />

                        <p>At Caritas Matha Hospital, our commitment to excellence in transfusion medicine ensures that patients receive prompt, safe, and effective blood transfusions when they need it most, supported by advanced technology and compassionate care.</p>
                        <br />
                    </div>
                </div>

                <div className="more-services">
                    <p className="more-services-heading">More Services</p>
                    <div className='more-services-links'>
                        <a href="/radiology-laboratory"><p> Radiology & Laboratory</p></a>
                        <a href="/clinical-nutrition"><p> Clinical Nutrition</p></a>
                        <a href="/insurance-partners"><p> Insurance Partners</p></a>
                        <a href="/caritas-mortuary-services"><p> Caritas Mortuary Services</p></a>
                        <a href="/pastoral-care"><p> Pastoral Care</p></a>
                        <a href="/caritas-home-care"><p> Caritas Home Care</p></a>
                        <a href="https://www.caritashospital.org/health-checkup-packages"><p> Health Checkup Packages</p></a>
                        <a href="/video-consultation"><p> Video Consultation</p></a>
                    </div>
                </div>
            </section>

            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default BloodBank;